module.exports = __webpack_public_path__ + "static/media/uk.ede8bc42.svg";